export default {
    general: {
        cancel:    'Prekliči',
        save:      'Shrani',
        sign_out:  'Odjava',
        more_info: 'Več informacij',
        loading:   'Nalaganje …',
    },
    brand: {
        product_name: 'Imprion ID',
        tagline:      'Prijava Imprion',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetli način',
        switch_to_dark:  'Preklopi na temni način',
    },
    login: {
        title:             'Prijava',
        title_refresh:     'Potrdite, da ste to vi',
        title_aal2:        'Preverjanje v dveh korakih',
        title_passkey:     'Potrdite s ključem za dostop',
        or:                'ali',
        too_many_attempts: 'Preveč neuspešnih poskusov. Poskusite znova pozneje.',
        signing_in_as:     'Prijavljate se kot {email}',
        other_account:     'Uporabi drug račun',
        passkey_instead:   'Uporabi ključ za dostop',
        totp_instead:      'Uporabi aplikacijo za preverjanje',
    },
    passkey: {
        failed:      'Ključa za dostop ni bilo mogoče uporabiti. Poskusite znova.',
        unsupported: 'Ta brskalnik ne podpira ključev za dostop.',
    },
    settings: {
        title:                 'Račun',
        second_factor_pending: 'Preverjanje v dveh korakih ni dokončano',
        expired:               'Obrazec je potekel. Poskusite znova.',
        setup: {
            title:    'Zavarujte svoj račun',
            required: 'Preden nadaljujete s prijavo, potrebuje vaš račun geslo in drugi dejavnik preverjanja.',
        },
        profile: {
            title: 'Osebni podatki',
            name:  'Ime in priimek',
            email: 'E-pošta',
            edit:  'Uredi',
        },
        password: {
            title:  'Geslo',
            change: 'Spremeni geslo',
            set:    'Geslo je nastavljeno.',
        },
        totp: {
            title:        'Aplikacija za preverjanje pristnosti',
            enrolled:     'Aplikacija za preverjanje pristnosti je nastavljena.',
            enrol:        'Nastavi',
            not_enrolled: 'Ni nastavljena.',
        },
        passkey: {
            title:        'Ključi za dostop',
            none:         'Ni še ključev za dostop.',
            unnamed:      'Ključ za dostop',
            added:        'Dodan {date}',
            add:          'Dodaj ključ za dostop',
            remove:       'Odstrani',
            last_passkey: 'To je edini ključ za dostop do računa, zato ga ni mogoče odstraniti.',
        },
    },
    invite: {
        title:   'Sprejem povabila',
        sign_in: 'Prijava',
        invalid: 'To povabilo ni veljavno. Za novo se obrnite na skrbnika.',
        expired: 'To povabilo je poteklo. Za novo se obrnite na skrbnika.',
    },
    enrol: {
        title_password:  'Nastavite geslo',
        title_choose:    'Dodajte drugi dejavnik',
        title_totp:      'Nastavite aplikacijo za preverjanje pristnosti',
        title_passkey:   'Ustvarite ključ za dostop',
        title_done:      'Nastavitev je končana',
        choose_totp:     'Aplikacija za preverjanje pristnosti',
        choose_passkey:  'Ključ za dostop',
        create_passkey:  'Ustvari ključ za dostop',
        back:            'Nazaj',
        done:            'Vaš račun je pripravljen. Za nadaljevanje se prijavite.',
        session_expired: 'Seja povabila je potekla. Za novo povabilo se obrnite na skrbnika.',
    },
    error: {
        title:     'Prišlo je do napake',
        messages: {
            generic:        'Zahteve ni bilo mogoče dokončati.',
            expired:        'Ta zahteva za prijavo je potekla ali je bila že uporabljena. Začnite znova v aplikaciji.',
            server:         'Storitev za prijavo je imela težavo. Poskusite znova čez trenutek.',
            denied:         'Dostop je bil zavrnjen.',
            login_required: 'Znova se morate prijaviti.',
            bad_request:    'Aplikacija je poslala zahtevo za prijavo, ki je ni bilo mogoče sprejeti. Obrnite se na skrbnika aplikacije.',
        },
        reference: 'Sklic: {reference}',
        to_login:  'Na prijavo',
    },
    logout: {
        question:   'Se želite odjaviti iz Imprion ID v tem brskalniku?',
        confirm:    'Odjava',
        cancel:     'Prekliči',
        title:      'Odjava',
        signed_out: 'Odjavljeni ste.',
        to_login:   'Prijava',
    },
    logout_confirm: {
        title:        'Se želite odjaviti iz vseh aplikacij Imprion?',
        scope:        'Odjavljeni boste samo v tem brskalniku, kolikor to omogoča posamezna aplikacija. Druge naprave ostanejo prijavljene.',
        requested_by: 'Zahteva aplikacije {name}',
        not_allowed:  'Ta aplikacija vas ne more odjaviti iz vseh aplikacij Imprion.',
        back:         'Nazaj v aplikacijo',
        gone:         'Ta zahteva za odjavo ni več veljavna.',
        retry:        'Odjave ni bilo mogoče dokončati. Poskusite znova.',
        try_again:    'Poskusi znova',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Ni dovoljenja',
    },
    validation: {
        required: 'To polje je obvezno',
        email:    'Neveljaven e-poštni naslov',
    },
    // Oznake in sporočila Kratosa po njegovi številki sporočila (libs/kratosUi.ts). Številka brez
    // vnosa prikaže Kratosovo angleško besedilo.
    kratos: {
        fields: {
            traits_email:      'E-pošta',
            traits_name_first: 'Ime',
            traits_name_last:  'Priimek',
        },
        messages: {
            1010001: 'Prijava',
            1010003: 'Potrdite, da ste to res vi.',
            1010004: 'Dokončajte drugi korak preverjanja.',
            1010006: 'Koda za preverjanje',
            1010009: 'Potrdi kodo',
            1010013: 'Nadaljuj',
            1010021: 'Prijava s ključem za dostop',
            1010022: 'Prijava z geslom',
            1050001: 'Spremembe so shranjene.',
            1050004: 'Izklopi aplikacijo za preverjanje pristnosti',
            1050005: 'Koda QR za aplikacijo za preverjanje pristnosti',
            1050017: 'To je skrivni ključ za aplikacijo za preverjanje pristnosti. Uporabite ga, če kode QR ne morete optično prebrati.',
            1050019: 'Dodaj ključ za dostop',
            1070001: 'Geslo',
            1070003: 'Shrani',
            1070006: 'Koda za potrditev',
            1070009: 'Nadaljuj',
            1070010: 'Koda iz povabila',
            4000002: 'Manjka polje {property}.',
            4000005: 'Gesla ni mogoče uporabiti: {reason}',
            4000006: 'Napačen e-poštni naslov ali geslo.',
            4000008: 'Koda za preverjanje ni pravilna. Poskusite znova.',
            4000031: 'Gesla ni mogoče uporabiti, ker je preveč podobno e-poštnemu naslovu.',
            4000032: 'Geslo mora imeti vsaj {min_length} znakov (vnesenih: {actual_length}).',
            4000033: 'Geslo ima lahko največ {max_length} znakov (vnesenih: {actual_length}).',
            4000034: 'Geslo se je pojavilo v znanih uhajanjih podatkov in ga ni več mogoče uporabljati.',
            4010001: 'Obrazec za prijavo je potekel. Poskusite znova.',
            4050001: 'Obrazec je potekel. Poskusite znova.',
            4060006: 'Koda ni veljavna ali je bila že uporabljena. Poskusite znova.',
        },
    },
}
